module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yh-label-input",
    style: ({
      height: _vm.height,
      width: _vm.width
    }),
    on: {
      "click": _vm.clickInput
    }
  }, [_c('div', {
    ref: "tagBox",
    staticClass: "yh-tag-box"
  }, _vm._l((_vm.tags), function(tag, index) {
    return _c('el-tag', {
      key: index,
      staticClass: "yh-tag",
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.delTag(index)
        }
      }
    }, [_vm._v(_vm._s(tag))])
  }), 1), _vm._v(" "), _c('el-input', {
    ref: "testInput",
    staticClass: "yh-tag-input",
    attrs: {
      "maxlength": _vm.maxTag,
      "placeholder": _vm.placeholder
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addTag.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.inputData),
      callback: function($$v) {
        _vm.inputData = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "inputData"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-fc80fb10","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/coupon/components/inputTag.vue
// module id = 1765
// module chunks = 0